export enum AvatarType {
    Avatar1 = 1,
    Avatar2 = 2,
    Avatar3 = 3,
    Avatar4 = 4,
    Avatar5 = 5,
    Avatar6 = 6,
}